var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('zm-button',{attrs:{"size":"large","round":"","type":"primary"},on:{"click":_vm.goToHDPage}},[_vm._v(" "+_vm._s(_vm.$t('billing.success.get_started')))])}
var staticRenderFns = []

export { render, staticRenderFns }